import apiRequest from "utils/ApiRequest/apiRequest.js";

export const getSupportCategoryQuestions = async (
  category,
  lang,
  setCategoryQuestions,
  setLoading,
  setNotExistsPage
) => {
  setLoading(true);
  const response = await apiRequest(
    "Contents",
    "GetAllSupportCategoriesQuestionsByCategoryList",
    {
      culture: lang,
      useCache: false,
      category: (category === "jumboembed"
        ? "jumbo-embed"
        : category === "receiving-and-downloading-files" && lang === "he-IL"
        ? "download"
        : category === "jumbopay"
        ? "aboutjambopay"
        : category.charAt(0).toLowerCase() + category.slice(1)
      ).replace(/-/g, "-"),
    }
  );

  if (response.status === "success") {
    if (response.data) {
      setCategoryQuestions(response.data);
    } else {
      setNotExistsPage(true);
    }
    setLoading(false);
  } else {
    setLoading(false);
  }
};

export const getSingleQuestion = async (
  lang,
  question,
  setQuestionDetails,
  setLoading,
  setNotExistsPage
) => {
  setLoading(true);
  const response = await apiRequest("Contents", "GetSingleSupportQuestion", {
    culture: lang,
    useCache: false,
    systemNameQuestion: question,
  });
  if (response.status === "success") {
    if (response.data) {
      if (response.data.AnswerText) {
        setQuestionDetails(response.data);
      } else {
        setNotExistsPage(true);
      }
      if (!response.data.Status) {
        setNotExistsPage(true);
      }
    } else {
      setNotExistsPage(true);
    }
    setLoading(false);
  } else {
    setLoading(false);
  }
};
